import { useSelector } from 'react-redux';
import { selectSchoolInfo } from 'redux/configuration/selector';

const useSchoolType = () => {
  const { basic_school_information_dto } = useSelector(selectSchoolInfo);
  const acquisition_type = basic_school_information_dto?.acquisition_type;
  return {
    acquisitionType: acquisition_type,
    isMadrasa: acquisition_type === 'MADRASA',
    isAcademicProfileActive: basic_school_information_dto?.uses_academic_profile,
    isExamReadyActive: basic_school_information_dto?.uses_exam_ready,
    isScoreAssessment: basic_school_information_dto?.uses_scores,
    isProjection: basic_school_information_dto?.uses_projection,
    isCollaborator: basic_school_information_dto?.uses_collaborator_role,
  };
};

export default useSchoolType;
